<template>
    <div>
        <page-header> Users </page-header>

        <vx-tabs v-if="showTabs" v-model="currentTab" size="lg" class="mb-8">
            <vx-tab value="active">Active</vx-tab>
            <vx-tab value="pending">
                <span class="relative">
                    Pending
                    <span class="absolute -inset-e-1.5 inset-bs-0 bg-sky-500 w-1.5 h-1.5 rounded-full"></span>
                </span>
            </vx-tab>
        </vx-tabs>

        <team-active-users
            v-show="currentTab === 'active'"
            :teamId="props.teamId"
            @add="inviteModal = true"
            :readOnly="props.readOnly"
        ></team-active-users>
        <team-pending-users
            v-show="currentTab === 'pending'"
            ref="pendingUsersRef"
            :teamId="props.teamId"
            @add="inviteModal = true"
            @deleted="onInviteDeleted"
            :readOnly="props.readOnly"
            :totalCount="invitesCount"
        >
        </team-pending-users>
        <team-user-modal-form
            v-model="inviteUser"
            v-model:visible="inviteModal"
            :teamId="props.teamId"
            @invited="onInvited"
        ></team-user-modal-form>
    </div>
</template>
<script setup>
import PageHeader from '~/components/general/PageHeader.vue';
import TeamActiveUsers from './TeamActiveUsers.vue';
import TeamPendingUsers from './TeamPendingUsers.vue';
import TeamUserModalForm from './TeamUserModalForm.vue';
import { VxTabs, VxTab } from '@voxie/frontend-components';
import { useToasted } from '~/composables/useToasted';
import { ref } from 'vue';
import { invitationsClient } from '~/services';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    readOnly: {
        type: Boolean,
        default: false,
    },
});

const toasted = useToasted();

const showTabs = ref(false);
const currentTab = ref('active');

const pendingUsersRef = ref();
const invitesCount = ref(0);
const inviteModal = ref(false);
const inviteUser = ref({
    email: '',
    role: '',
});

invitationsClient
    .invitesCount(props.teamId)
    .then(({ data }) => {
        invitesCount.value = data.count || 0;
        showTabs.value = invitesCount.value > 0;
    })
    .catch((e) => {
        console.error(e);
        toasted.global.platform_error();
    });

const onInvited = () => {
    pendingUsersRef?.value?.loadData();
    invitesCount.value++;
    showTabs.value = true;
};

const onInviteDeleted = () => {
    invitesCount.value--;
    showTabs.value = invitesCount.value > 0;

    currentTab.value = showTabs.value ? 'pending' : 'active';
};
</script>
